/**
 * Fire-and-forget tracker for treatment link clicks.
 * Never throws — a tracking failure must never block navigation.
 */
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function trackTreatmentView({ slug, label, href }) {
  try {
    if (!slug) return;
    // Use Beacon when available so the request survives a page navigation.
    const payload = JSON.stringify({ slug, label, href });
    if (typeof navigator !== "undefined" && navigator.sendBeacon) {
      const blob = new Blob([payload], { type: "application/json" });
      navigator.sendBeacon(`${API}/treatments/track-view`, blob);
      return;
    }
    fetch(`${API}/treatments/track-view`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: payload,
      keepalive: true,
    }).catch(() => {});
  } catch {
    /* swallow — tracking is best-effort */
  }
}
